import { render, staticRenderFns } from "./QuotaConfig.vue?vue&type=template&id=26a4a85d&scoped=true"
import script from "./QuotaConfig.vue?vue&type=script&lang=js"
export * from "./QuotaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a4a85d",
  null
  
)

export default component.exports